import { ROLES } from 'config';

const plansConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('plans', {
      url: '/admin/plans',
      template: '<app-plans></app-plans>',
      access: {
        loginRequired: true,
        roles: [ROLES.ADMIN],
      },
    });
};

export default plansConfig;



// WEBPACK FOOTER //
// ./src/modules/plans/plans.config.js